export default class FormCategory {
    public id : string = '';
    public name : string = '';
    public selected : boolean = true;
}